// src/pages/PrimaryChapter.jsx
import React from "react";
import { useParams } from "react-router-dom";

export default function PrimaryChapter() {
  const { classId, subject, chapterId } = useParams();

  const chapterContent = {
    text: "This is chapter lesson content. Add your detailed explanation here.",
    video: "https://www.youtube.com/embed/ZqLeGm4k6CU",
    audio: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
  };

  return (
    <div className="min-h-screen p-6 bg-white">
      <h1 className="text-3xl font-bold mb-6 text-center">
        {classId} - {subject} - {chapterId}
      </h1>

      {/* Text */}
      <div className="mb-6 bg-gray-100 p-4 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-2">Lesson Text</h2>
        <p>{chapterContent.text}</p>
      </div>

      {/* Video */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Video</h2>
        <iframe
          width="100%"
          height="315"
          src={chapterContent.video}
          title="Lesson Video"
          allowFullScreen
          className="rounded-lg shadow"
        />
      </div>

      {/* Audio */}
      <div>
        <h2 className="text-xl font-semibold mb-2">Audio</h2>
        <audio controls className="w-full">
          <source src={chapterContent.audio} type="audio/mpeg" />
        </audio>
      </div>
    </div>
  );
}
